import RsaGestioneCentroDiurno from "../";

const routes = [{ name: "RsaGestioneCentroDiurnoListPage", path: "/rsagestionecentrodiurno", component: RsaGestioneCentroDiurno.RsaGestioneCentroDiurnoListPage, meta: { title: "R.S.A. - Gestione Presenze" } }];
export default routes;
